import { merge } from "es-toolkit/object";
import { assertObject } from "./assert";
import { DeepPartial } from "./DeepPartial";

export function mergeUserOptions<T>(options: T, userOptions?: DeepPartial<T>): void {
    if (typeof userOptions === "undefined") {
        return;
    }

    assertObject(userOptions, "userOptions");

    const target = options as Record<string, unknown>;
    const source = userOptions as Record<string, unknown>;

    for (const key of Object.keys(source)) {
        const targetValue = target[key];
        const sourceValue = source[key];

        
        const temp = { [key]: targetValue };
        merge(temp, { [key]: sourceValue });

        try {
            target[key] = temp[key];
        } catch {
            
        }
    }
}
